__turbopack_context__.v({
  "no-javascript": "no-javascript-module-scss-module__ensJUa__no-javascript",
});
